module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/config/i18n/message-jp.json
// module id = rL8M
// module chunks = 19